export default "__VITE_ASSET__osyxC7Gy__"